import { IGcpAppDispatch } from "../../../redux/store";
import { IStoreState } from "../../../redux/rootReducer";
import { IGcpAppIo } from "../../../redux/io";
import { SIDEBAR_CLOSED } from "../../../tracking/constants";
import { invalidateSize } from "../../../map/reusableLayers/NavigationLayer/NavigationLayer";
import { toggleSidebarVisibility } from "../../../redux/modules/modePilotUi/reducer";

const userTogglesSidebarVisibility =
  () =>
  (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    trackAction(SIDEBAR_CLOSED);
    dispatch(toggleSidebarVisibility());
    dispatch(invalidateSize());
  };

export default userTogglesSidebarVisibility;
